import { render } from "./ChangeoverReport.vue?vue&type=template&id=2baab20b&scoped=true"
import script from "./ChangeoverReport.vue?vue&type=script&lang=js"
export * from "./ChangeoverReport.vue?vue&type=script&lang=js"

import "./ChangeoverReport.vue?vue&type=style&index=0&id=2baab20b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2baab20b"]])

export default __exports__
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtnGroup,QBtn,QTooltip,QIcon});
